export default "__VITE_PUBLIC_ASSET__e1067e13__"